import { UseMutationOptions } from '@tanstack/react-query';

import { InventoryPolicy } from '@playq/octopus2-economy';
import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

export const usePolicyInventoryUpdate = (
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, InventoryPolicy>
) => {
  return useEitherMutation((policy) => services2.inventoryAdminService.updatePolicy(policy), options);
};
